import React from "react";
import "./NavDropdown.css";

/**
 * Dropdown sub component of Nav
 * Closes dropdown on outside click
 *
 * @property string header (element of the top arrow element)
 * @property array children (list of components who will render in <li>)
 */
export default class NavDropdown extends React.Component {
  state = {
    isExpanded: false
  };

  getTopLevelClass() {
    if (this.state.isExpanded) {
      return "Nav__Dropdown Nav__Dropdown__active";
    }

    return "Nav__Dropdown";
  }

  toggleState() {
    this.setState({
      isExpanded: !this.state.isExpanded
    });
  }

  render() {
    return (
      <div
        className={this.getTopLevelClass()}
        ref={this.setWrapperRef}
        title={this.props.title}
      >
        <a
          className="Nav__Dropdown__Header"
          onClick={this.toggleState.bind(this)}
        >
          {this.props.header}
        </a>
        <ul
          className="Nav__List Nav__Dropdown__Menu"
          onClick={this.toggleState.bind(this)}
        >
          {React.Children.map(this.props.children, (link, key) => (
            <li className="Nav__List__Item Nav__Dropdown__Menu__Item" key={key}>
              {link}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/Sidebar/NavDropdown.js